export interface ShimmedEnv {
  fkUA?: string | undefined;
  platform?: string | undefined;
  locale?: string | undefined;
  isLoggedIn?: boolean | undefined;
  abConfig?: any | undefined;
  SN?: string | undefined;
  SC?: string | undefined;
  secureToken?: string | undefined;
  appVersion?: string | number | undefined;
  omnitureVisitorId?: string | number | undefined;
  [key: string]: any;
}
export interface AppWindow extends Window {
  [index: string]: any | undefined;
}

export interface AppPlatform {
  isAndroid: boolean;
  isMSite: boolean;
  isIOS: boolean;
  localStorageAvailable: boolean;
  sessionStorageAvailable: boolean;
  isWindows: boolean;
  current: string;
  envShim: ShimmedEnv;
}
export interface IosInterface {
  method: string;
  args: any;
  onSuccess: (P?: any) => void;
  onFailure: (P?: any) => void;
}
export interface IRichViewBridgeParams {
  method: string;
  params?: any;
  isSetupCallbackRequiredForAndroid?: boolean;
}
export interface RichViewBridge {
  invoke: (params: IRichViewBridgeParams) => Promise<any>;
  exists: boolean;
}

export enum PlatformType {
  ANDROID = 'android',
  WEB = 'web',
  IOS = 'ios',
  WINDOWS = 'windows',
  DESKTOP = 'desktop'
}

export interface setupOnSuccessBridgeCBParams {
  globalEnv: AppWindow;
  onSuccessBridgeCB: string;
  onFailureBridgeCB: string;
  resolve: (param?: any) => any;
}

export interface setupOnFailureBridgeCBParams {
  globalEnv: AppWindow;
  onFailureBridgeCB: string;
  reject: (param?: any) => any;
  genericRejection: string;
}
